import React from 'react';
import { useTranslation } from 'react-i18next';
import MainButton from '../../../../components/buttons/main';
import { splitBillSteps } from '../../models/splitBillSteps';

const SplitBillOptions = ({ onSelect }) => {
  const { t } = useTranslation();

  return (
    <div className="mt-10 mb-3 pb-10 max-w-xs mx-auto">
      <MainButton
        text={t('buttons.payForItems')}
        outline
        onClick={() => onSelect(splitBillSteps.items)}
      />
      <div className="mt-3" />
      <MainButton
        text={t('buttons.divideBillEqually')}
        outline
        onClick={() => onSelect(splitBillSteps.divide)}
      />
      <div className="mt-3" />
      <MainButton
        text={t('buttons.payCustom')}
        outline
        onClick={() => onSelect(splitBillSteps.custom)}
      />
    </div>
  );
};

export default SplitBillOptions;
